import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '../lib/cn.js';
const Provider = TooltipPrimitive.Provider;
/** Is a {@link SharedProvider} up the tree? (Radix does not expose its own.) */
const SharedPresence = React.createContext(false);
/**
 * The app-wide tooltip provider (one in `AppShell`, one in Storybook's
 * preview): every tooltip below shares its delays, so moving along a toolbar
 * opens the next tooltip at once instead of re-waiting per button. Components
 * that need a provider to work alone (`IconButton`) check for it with
 * {@link useSharedTooltipProvider} and add their own only outside one.
 */
function SharedProvider({ delayDuration = 300, ...props }) {
    return (_jsx(SharedPresence.Provider, { value: true, children: _jsx(TooltipPrimitive.Provider, { delayDuration: delayDuration, ...props }) }));
}
/** `true` inside a `Tooltip.SharedProvider`. */
export const useSharedTooltipProvider = () => React.useContext(SharedPresence);
const Root = TooltipPrimitive.Root;
const Trigger = TooltipPrimitive.Trigger;
const Content = React.forwardRef(({ className, sideOffset = 4, ...props }, ref) => (_jsx(TooltipPrimitive.Portal, { children: _jsx(TooltipPrimitive.Content, { ref: ref, sideOffset: sideOffset, className: cn('z-50 overflow-hidden rounded-[var(--radius-2)] bg-[var(--color-surface-inverse)] px-2 py-1 text-xs text-[var(--color-text-inverse)] shadow-md', className), ...props }) })));
Content.displayName = 'Tooltip.Content';
export const Tooltip = Object.assign(Root, {
    Provider,
    SharedProvider,
    Root,
    Trigger,
    Content,
});
//# sourceMappingURL=tooltip.js.map